import request from '@/utils/seftRequest';

// 查询可用号码列表
export function qryAvailableAccNbrList(params) {
  return request('/ding/custService/qryAvailableAccNbrListBsnl', {
    method: 'POST',
    body: params,
  });
}

// 查询 NumberType
export function qryServiceTypeBsnl() {
  return request('/ding/custService/qryServiceTypeBsnl');
}

// 查询号码等级
export function qryAccNbrClass() {
  return request('/ding/subsService/qryAccNbrClassBsnl');
}

// 号码预占和解锁
export function operAccNbr(data) {
  return request('/ding/custService/operAccNbr', {
    method: 'POST',
    body: data,
  });
}
